/* Footer "Cookie settings" reopens Shopify's cookie banner preferences. window.privacyBanner
   comes from storefront-banner.js, an async script in content_for_header, so the item is checked
   on window load, which async scripts hold back. Without JavaScript or without that API it stays hidden. */
(() => {
  const banner = () => (typeof window.privacyBanner?.showPreferences === 'function' ? window.privacyBanner : null);
  const sync = () => document.querySelectorAll('[data-cookie-settings]').forEach((item) => { item.hidden = !banner(); });
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-cookie-settings] button')) banner()?.showPreferences();
  });
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'complete') sync();
  else window.addEventListener('load', sync, { once: true });
})();
